import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Repeat"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 4.5H4.3725L7.0575 1.8075L6 0.75L1.5 5.25L6 9.75L7.0575 8.6925L4.3725 6H19.5V11.25H21V6C21 5.17157 20.3284 4.5 19.5 4.5ZM16.9425 15.3075L19.6275 18H4.5V12.75H3V18C3 18.8284 3.67157 19.5 4.5 19.5H19.6275L16.9425 22.1925L18 23.25L22.5 18.75L18 14.25L16.9425 15.3075Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Repeat.vue"]]);
